import Vue from 'vue';
import Vuex from 'vuex';
import createPersistedState from 'vuex-persistedstate';
import axios from 'axios';
import bus from '@/utils/bus';
import router from '@/router';
import VueCookies from 'vue-cookies';

Vue.use(Vuex);
Vue.use(VueCookies);

const isChild = localStorage.getItem('password') === null ? false : true;

export default new Vuex.Store({
  plugins: [createPersistedState()],

  state: {
    profile: {},
    banners: [],
    issueOfTheDay: [],
    playlists: [],
    recommended: [],
    weeklyTop: [],
    news: [],
    editorsChoice: [],
    favorites: [],
    categories: [],
    allCategories: [],
    myCategories: [],
    activeSubscription: false,
    lang: 'en'
  },

  mutations: {
    async logout() {
      /*
       state.profile = {},
       state.banners = [],
       state.issueOfTheDay = [],
       state.playlists = [],
       state.recommended = [],
       state.weeklyTop = [],
       state.favorites = [],
       state.categories = [],
       state.allCategories = [],
       state.myCategories = [],
       state.activeSubscription = false,
       */
      Vue.cookies.remove('sctoken');
      // eslint-disable-next-line no-undef
      $cookies.remove('sctoken');
      localStorage.removeItem('vuex');
      window.localStorage.removeItem('vuex');
      const lastPageLogin = await Vue.cookies.get('scloginpage');
      if (lastPageLogin === 'neo') {
        return router.push({
          name: 'neo'
        });
      }
      if (lastPageLogin === 'isp') {
        return router.push({
          name: 'isp'
        });
      }
      router.push({
        name: 'login'
      });
    },
    setLang(state, obj) {
      state.lang = obj;
    },
    doLogin(context, obj) {
      context.profile = obj.profile;
    },

    setProfile(state, obj) {
      state.profile.id = obj.id;
      state.profile.name = obj.name;
      state.profile.display_name = obj.display_name;
      state.profile.email = obj.email;
      state.profile.is_vivo = obj.is_vivo;
      state.profile.operator_name = obj.operator_name;
      state.profile.msisdn = obj.msisdn;
      state.profile.region = obj.region;
      state.profile.show_banner_club = obj.show_banner_club;
      state.profile.idp = obj.idp;
      state.profile.login_type = obj.login_type;
    },

    setSubscription(state, active) {
      if (typeof active !== 'undefined') {
        state.activeSubscription = active;
      }
    },

    setHome(state, obj) {
      state.banners = obj.banners;
      state.issueOfTheDay = obj.issueOfTheDay;
      state.playlists = obj.playlists;
      state.news = obj.news;
      state.editorsChoice = obj.editorsChoice;
      state.recommended = obj.recommended;
      state.weeklyTop = obj.weeklyTop;
    },

    setFavorites(state, obj) {
      state.favorites = obj;
    },

    clearFavorites(state) {
      state.favorites = [];
    },

    setCategories(state, obj) {
      state.categories = obj;
    },

    setAllCategories(state, obj) {
      state.allCategories = obj;
    },

    setMyCategories(state, obj) {
      state.myCategories = obj;
    }
  },

  getters: {
    lang: state => state.lang,
    profile: state => state.profile,
    banners: state => state.banners,
    issueOfTheDay: state => state.issueOfTheDay,
    playlists: state => state.playlists,
    recommended: state => state.recommended,
    weeklyTop: state => state.weeklyTop,
    news: state => state.news,
    editorsChoice: state => state.editorsChoice,
    favorites: state => state.favorites,
    categories: state => state.categories,
    allCategories: state => state.allCategories,
    myCategories: state => state.myCategories,
    activeSubscription: state => {
      if (typeof state.activeSubscription === 'boolean') {
        return state.activeSubscription;
      }
      return state.activeSubscription === 'true' ? true : false;
    }
  },

  actions: {
    // async fetchLogin ({commit}) {
    // 	axios.get('/new-login')
    // 		.then(response => {
    // 			commit('setProfile', response.data)
    // 			commit('setSubscription', response.headers['active-subscription'])
    // 		})
    // 		.catch(e => {
    // 			console.error(e)
    // 		})
    // },

    async getProfile({ commit }) {
      // const that = this;
      axios
        .get('/profiles/me/web')
        .then(response => {
          commit('setProfile', response.data);
          commit('setSubscription', response.headers['active-subscription']);
        })
        .catch(error => {
          console.error('error.response.status', error.response);
          // if (error.response.status == 404 || error.response.status == 401) {
          // 	// router.push('logout')
          // 	this.$store.commit("logout");
          // 	this.$router.push({
          // 		name: "welcome"
          // 	});
          // }
        });
    },

    async getHome({ commit }) {
      if (isChild) {
        await axios
          .get('/child/home')
          .then(response => {
            commit('setSubscription', response.headers['active-subscription']);
            commit('setHome', response.data);
          })
          .catch(e => {
            bus.$emit(
              'snackbar',
              'An error occurred while loading this page',
              'primary',
              2000
            );
            console.error(e);
          });
      } else {
        await axios
          .get('/home')
          .then(response => {
            commit('setSubscription', response.headers['active-subscription']);
            commit('setHome', response.data);
          })
          // eslint-disable-next-line no-unused-vars
          .catch(e => {
            bus.$emit(
              'snackbar',
              'An error occurred while loading this page',
              'primary',
              2000
            );
            console.error(e);
          });
      }
    },

    async getFavorites({ commit }) {
      if (isChild) {
        await axios
          .get('/api/issues/child/favorites')
          .then(response => {
            // console.info(response.data)
            commit('setSubscription', response.headers['active-subscription']);
            commit('setFavorites', response.data.results);
          })
          // eslint-disable-next-line no-unused-vars
          .catch(e => {
            bus.$emit(
              'snackbar',
              'An error occurred while loading this page',
              'primary',
              2000
            );
            console.error(e);
          });
      } else {
        await axios
          .get('/api/issues/favorites')
          .then(response => {
            // console.info(response.data)
            commit('setSubscription', response.headers['active-subscription']);
            commit('setFavorites', response.data.results);
          })
          // eslint-disable-next-line no-unused-vars
          .catch(e => {
            bus.$emit(
              'snackbar',
              'An error occurred while loading this page',
              'primary',
              2000
            );
            console.error(e);
          });
      }
    },

    async getCategories({ commit }) {
      if (isChild) {
        axios
          .get('/api/titles?categoryId=3')
          .then(response => {
            console.info(response.data);

            this.titles = response.data.titles;

            this.loaded = true;
            bus.$emit('loading', false);
            commit('setSubscription', response.headers['active-subscription']);
            //this.$router.push('/explore/category/3/Infantil');
          })
          .catch(e => {
            console.error(e);
            this.errors.push(e);
            this.loaded = true;
            bus.$emit('loading', false);
          });
      } else {
        await axios
          .get('/api/categories')
          .then(response => {
            // console.info(response.data)
            commit('setSubscription', response.headers['active-subscription']);
            commit('setCategories', response.data.categories);
          })
          // eslint-disable-next-line no-unused-vars
          .catch(e => {
            bus.$emit(
              'snackbar',
              'An error occurred while loading this page',
              'primary',
              2000
            );
            // console.error(e)
          });
      }
    },

    async getAllCategories({ commit }) {
      axios
        .get('/api/categories/all')
        .then(response => {
          commit('setSubscription', response.headers['active-subscription']);
          commit('setAllCategories', response.data.categories);
        })
        // eslint-disable-next-line no-unused-vars
        .catch(e => {
          bus.$emit(
            'snackbar',
            'An error occurred while loading this page',
            'primary',
            2000
          );
          // console.error(e)
        });
    },

    async getMyCategories({ commit }) {
      await axios
        .get('/api/categories')
        .then(response => {
          // console.info(response.data)
          commit('setSubscription', response.headers['active-subscription']);
          commit('setMyCategories', response.data.categories);
        })
        // eslint-disable-next-line no-unused-vars
        .catch(e => {
          bus.$emit(
            'snackbar',
            'An error occurred while loading this page',
            'primary',
            2000
          );
          // console.error(e)
        });
    },

    async setMyCategories({ commit }, chosenCategories) {
      let categories = [];
      chosenCategories.map(item => {
        categories.push(item.id);
      });
      let body = {
        categoryIds: categories
      };

      await axios
        .post('/profiles/me/categories', body)
        .then(response => {
          commit('setSubscription', response.headers['active-subscription']);
          commit('setMyCategories', chosenCategories);
        })
        // eslint-disable-next-line no-unused-vars
        .catch(e => {
          bus.$emit(
            'snackbar',
            'An error occurred while loading this page',
            'primary',
            2000
          );
          // console.error(e)
        });
    },

    // eslint-disable-next-line no-unused-vars
    async postLogin({ commit }, payload) {
      const idToken = {
        idToken: payload.idToken
      };

      //console.log('payload.authorizationCode', payload.authorizationCode);
      //http://stg.supercomics.com.br/api/new-login
      return new Promise((resolve, reject) => {
        axios
          .post('/api/new-login', idToken)
          .then(response => {
            if (response.data.token) {
              Vue.cookies.set('sctoken', response.data.token, '1y');
              Vue.cookies.set('scloginpage', 'sc');
              resolve(response);
            } else {
              reject('Houve um erro, tente novamente mais tarde.');
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    }
  }
});
